__turbopack_context__.v({
  "className": "lexend_9ceb6e92-module__qIw2_q__className",
});
